/// <amd-module name="Test/TestPlansHubRefresh/TestHub/Redux/TestHubRefresh/TestHubRefreshSelector" />
import { ITestHubRefreshAwareState } from "Test/TestPlansHubRefresh/TestHub/Redux/TestHubRefresh/TestHubRefreshContracts";
import * as TestHubResources from "Test/TestPlansHubRefresh/TestHub/Resources";

export const isAdvancedLicenseEnabled = (state: ITestHubRefreshAwareState): boolean => state.testHubRefreshState.isAdvancedExtensionEnabled;

export const isShowTestsFromChildSuitesEnabled = (state: ITestHubRefreshAwareState): boolean => state.testHubRefreshState.isShowTestsFromChildSuitesEnabled;

export const getPlanId = (state: ITestHubRefreshAwareState): number => {
    return state.testHubRefreshState.testPlanId;
};

// getSelectedSuiteId: returns the currently selected suite id
export const getSelectedSuiteId = (state: ITestHubRefreshAwareState): number => state.testHubRefreshState.selectedSuiteId;

// getInitiallySelectedSuiteId: returns the initially selected suite id when the page was loaded. This never changes. This is the suite id for which json island contains the data for.
export const getInitiallySelectedSuiteId = (state: ITestHubRefreshAwareState): number => state.testHubRefreshState.initialSelectedSuiteId;

export const getTestCasePageSize = (state: ITestHubRefreshAwareState): number => state.testHubRefreshState.testCasePageSize;

export const getTestPointPageSize = (state: ITestHubRefreshAwareState): number => state.testHubRefreshState.testPointPageSize;

/**
 * Used for cases where display name is returned of the form 'Azure BugBash <azbash@microsoft.com>'
 * This happens when you update the work item in WIT form.
 */
export function getIdentityDisplayString(identityDisplayName: string) {
    let displayName: string = TestHubResources.UnassignedString;

    if (!identityDisplayName || identityDisplayName.trim().length <= 0) {
        return displayName;
    }

    displayName = identityDisplayName;

    const index: number = identityDisplayName.indexOf("<");
    if (identityDisplayName && index > 0) {
        displayName = identityDisplayName.substr(0, index - 1);
    }

    return displayName;
}

export const getExecuteColumnOptionFields = (state: ITestHubRefreshAwareState): string[] | undefined => {
    return state.testHubRefreshState.executeColumnOptionFields;
};

export const getDefineColumnOptionFields = (state: ITestHubRefreshAwareState): string[] | undefined => {
    return state.testHubRefreshState.defineColumnOptionFields;
};

export const getDefineTabCustomColumnFieldMap = (state: ITestHubRefreshAwareState) => {
    return state.testHubRefreshState.defineTabCustomColumnFieldMap;
};

export const getExecuteTabCustomColumnFieldMap = (state: ITestHubRefreshAwareState) => {
    return state.testHubRefreshState.executeTabCustomColumnFieldMap;
};